module.exports = "img/16.7a435c.webp";